module.exports = __webpack_public_path__ + "img/icon_enterpriserealty_overview_02.c8e0a3b4.svg";